export function getExpenseRemaining(expense) {
  if (expense.remaining_amount !== null && expense.remaining_amount !== undefined &&
      Number.isFinite(Number(expense.remaining_amount))) return Math.max(Number(expense.remaining_amount), 0);
  const due = Number(expense.due_amount);
  return Number.isFinite(due) && due > 0 ? due :
    Math.max(Number(expense.amount || 0) - Number(expense.paid_amount || 0), 0);
}

export function getExpensePaymentState(expense) {
  if (["Payé", "Partiellement payé", "Non payé"].includes(expense.payment_status)) return expense.payment_status;
  const amount = Number(expense.amount || 0);
  const paid = Number(expense.paid_amount || 0);
  return amount > 0 && paid >= amount ? "Payé" : paid > 0 ? "Partiellement payé" : "Non payé";
}

export function getExpensePrimaryAction(expense, { canPay, canEdit }) {
  if (getExpensePaymentState(expense) === "Payé" || getExpenseRemaining(expense) <= 0) return "view";
  if (!expense.supplier_id) return canEdit && Number(expense.paid_amount || 0) <= 0 ? "complete" : "view";
  return canPay ? "payment" : "view";
}

export function formatExpenseAmount(value) {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) return "—";
  const amount = Number(value);
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "XOF",
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2, maximumFractionDigits: 2 }).format(amount);
}
export function getExpenseDocuments(expense = {}) {
  let documents = expense.document_attachments;
  if (typeof documents === 'string') {
    try { documents = JSON.parse(documents); } catch { documents = null; }
  }
  if (Array.isArray(documents)) return documents;
  return expense.document_url ? [{ url: expense.document_url, name: expense.document_name || 'Pièce justificative' }] : [];
}
